import { Permissions } from '../../models/enums/permissions';
import * as React from 'react';
import { HasPermission } from '../../containers/authorization-helpers/HasPermission';

// #region Component Props

interface IProps {
    onSave          : any;
    saveLabel?      : string;
    onCancel        : any;
    cancelLabel?    : string;
    onEdit          : any;
    editLabel?      : string;
    id              : string;
    classList?      : string;
    disableSave?    : boolean;
    isEditMode      : boolean;
    permissions     : Permissions[];
}

// #endregion

const FormSave = (props : IProps) => {
    
    return <div className={"form-actions " + props.classList }>
            <HasPermission requiredPermissions={ props.permissions }> 
            {
                props.isEditMode 
                    ? <React.Fragment>
                        <button 
                            id="form-submit"
                            type="button"
                            disabled={ props.disableSave }
                            onClick={ props.onSave }
                            className="btn action">
                            { props.saveLabel }
                        </button>
                        {                
                            props.onCancel ?
                            <div className="col-auto">
                                <button 
                                    id="form-cancel"
                                    type="button"
                                    onClick={ props.onCancel }
                                    className="btn invert">
                                    { props.cancelLabel }
                                </button>
                            </div> : null
                        }
                    </React.Fragment>
                    : <button 
                        id="form-submit"
                        type="button"
                        onClick={ props.onEdit }
                        className="btn action">
                        { props.editLabel }
                    </button>
            }
            </HasPermission>
        </div>;
}

FormSave.defaultProps = {
    classList: '',
    disableSave: false,
    saveLabel: 'Save',
    cancelLabel: 'Cancel',
    onCancel: () => {return;},
    editLabel: 'Edit',
    deleteLabel: 'Delete',
    isEditMode: false,
    permissions: []
};

interface IPageActionProps {
    onSave?             : any;
    saveLabel?          : string;
    onSaveDisable?      : boolean;
    savePermissions?    : Permissions[];
    onEdit              : any;
    editLabel?          : string;
    onEditDisable?      : boolean;
    onDelete?           : any;
    deleteLabel?        : string;
    onDeleteDisable?    : boolean;
    id                  : string;
    classList?          : string;
    editPermissions     : Permissions[];
    deletePermissions?  : Permissions[];
}

const PageActions = (props : IPageActionProps) => {
    
    return <div className={"page-action-buttons " + props.classList }>
            {
                props.savePermissions && props.savePermissions.length > 0 && props.onSave
                    ? <HasPermission requiredPermissions={ props.savePermissions }>
                        <button
                            id="form-save"
                            type="button"
                            role="button"
                            onClick={ props.onSave }
                            name="form-save"
                            data-testid="form-save"
                            disabled={ props.onSaveDisable }
                            className="btn new">
                            { props.saveLabel }
                        </button>
                    </HasPermission>
                    : null
            }
            {
                props.deletePermissions && props.deletePermissions.length > 0 && props.onDelete
                    ? <HasPermission requiredPermissions={ props.deletePermissions }> 
                        <button 
                            id="form-cancel"
                            type="button"
                            role="button"
                            onClick={ props.onDelete }
                            name="form-save-delete"
                            data-testid="form-save-delete"
                            disabled={ props.onDeleteDisable }
                            className="btn new negative">
                            { props.deleteLabel }
                        </button>
                    </HasPermission>
                    : null
            }
            {
                props.editPermissions.length > 0
                ? <HasPermission requiredPermissions={ props.editPermissions }>
                    <button 
                        id="form-submit"
                        type="button"
                        role="button"
                        data-testid="form-save-edit"
                        name="form-save-edit"
                        onClick={ props.onEdit }
                        disabled={ props.onEditDisable }
                        className="btn new">
                        { props.editLabel }
                    </button>
                </HasPermission>
                : null
            }
        </div>;
};

PageActions.defaultProps = {
    saveLabel: 'Save',
    onSaveDisable: false,
    deleteLabel: 'Delete',
    onDeleteDisable: false,
    editLabel: 'Edit',
    onEditDisable: false
};

export { FormSave, PageActions };
